import { defineComponent as _defineComponent } from 'vue'
import { type PropType, useRoute } from "@nuxtjs/composition-api";

import { shareButtonDataByRoute } from "@/components/creator-shop/collection/shareButtonDataByRoute";
import { useAmplitude, useLinkService } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareButton',
  props: {
  fab: {
    type: Boolean,
    required: false,
    default: false,
  },
  shareTitle: {
    type: String,
    required: true,
  },
  shareText: {
    type: String,
    required: true,
  },
  shareUrl: {
    type: String as PropType<string | undefined>,
    required: false,
    default: undefined,
  },
  eventProperties: {
    type: Object as PropType<{ [key: string]: string | boolean } | undefined>,
    required: false,
    default: undefined,
  },
  isRunway: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const linkService = useLinkService();
const route = useRoute();
const amplitude = useAmplitude();

async function sendShareEvent(start = true) {
  let webSharePath = "";
  let referringComponent = "";

  if (route.value.name && route.value.name in shareButtonDataByRoute) {
    webSharePath = shareButtonDataByRoute[route.value.name].webSharePath;
    referringComponent = shareButtonDataByRoute[route.value.name].referringComponent;

    // Second event fires for these two routes
    if (route.value.name === "explore-displayName-posts-id" || route.value.name === "collections-hash") {
      amplitude?.sendEvent("/page/share", { "referring-component": referringComponent });
    }
  }
  if (props?.eventProperties && props?.eventProperties["gift-guide"] !== undefined) {
    amplitude?.sendEvent(start ? "/share/product-set/start" : "/share/cancel", {
      "referring-component": referringComponent,
      ...props.eventProperties,
    });
  }
  amplitude?.sendEvent(start ? "/share/start" : "/share/cancel", {
    "referring-component": referringComponent,
    ...props.eventProperties,
  });

  const shareData = {
    title: props.shareTitle,
    text: `${props.shareText}`,
    url:
      linkService.getUtmParams({ url: props.shareUrl ?? window.location.href ?? "", webSharePath }) ??
      window.location.href,
  };

  try {
    const result = await navigator.share(shareData);
    // This is temporary until the data team does an audit on events and streamlines them
    if (result === undefined) {
      if (props?.eventProperties && props?.eventProperties["gift-guide"] !== undefined) {
        amplitude?.sendEvent(start ? "/share/product-set/complete" : "/share/cancel", {
          "referring-component": referringComponent,
          ...props.eventProperties,
        });
      }
      amplitude?.sendEvent("/share/complete", { "referring-component": referringComponent });
    }
  } catch (error) {
    if (error instanceof DOMException && error.name === "AbortError") {
      sendShareEvent(false);
    }
  }
}

return { __sfc: true,props, linkService, route, amplitude, sendShareEvent }
}

})